import { Button } from "@shapr3d/frontend-lib";

import { useTracker } from "../../../../hooks/useTracker";
import { ElementClickAction, ElementClickLocation } from "../../../../lib/TrackingAdapter";
import { navigateToAuth } from "../../../../utils/authUtils";

import style from "./LoginButton.module.css";

export const LoginButton = () => {
  const tracker = useTracker();

  return (
    <Button
      aria-label="login"
      className={style.loginButton}
      onClick={() => {
        tracker.trackButtonClick({
          action: ElementClickAction.LOGIN,
          location: ElementClickLocation.HEADER,
        });
        navigateToAuth();
      }}
    >
      Log in
    </Button>
  );
};
